import client from "@/plugins/axios-plugin";
import Vue from "vue";

export default async function(deviceData){
    const token =  Vue.$cookies.get("token");
    if(!token) return null;
    try {
        const data = await client.post("/device", {
            "deviceName": deviceData.deviceName,
            "deviceId": deviceData.deviceId,
            "description": deviceData.description,
            "defaultCalibration": deviceData.defaultCalibration,
            "precision": parseInt(deviceData.precision),
            "interval": parseInt(deviceData.interval)
          }
          ,{
            headers: {
                authorization: token,
            }
        })
        return data.data;
    } catch (error) {
        
    }
    return null;
}